var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"app-icon bvi-no-styles",class:_vm.$style.icon,style:({
    maskImage: `url(${_vm.path})`,
  }),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }